// import Vue from 'vue';
const state = {
	settings: localStorage.getItem("betika-mobile-settings")
		? JSON.parse(localStorage.getItem("betika-mobile-settings"))
		: null,
};

const persistSettings = (settings) => {
	localStorage.setItem("betika-mobile-settings", JSON.stringify(settings));
};

const getDefaultSettings = () => {
	return Object.assign(
		{},
		{
			notifications: {
				status: null,
			},
			autorefresh: {
				status: false,
			},
			themeV2: {
				dark: false,
			},
			hideLostBets: false,
			appDownloadLinkTimestamp: null,
			seeRecommendations: false,
		}
	);
};

const getters = {
	settings: (state) => {
		return state.settings ? state.settings : getDefaultSettings();
	},
};

const mutations = {
	initSettingsFromAPI(state, freshSettings) {
		state.settings = Object.assign({}, freshSettings);
		persistSettings(freshSettings);
	},
	updateNotifications(state, val) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.notifications.status = val;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
	useAppTimeStamp(state, val) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.appDownloadLinkTimestamp = val;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
	toggleAutorefresh(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.autorefresh.status = !settings.autorefresh.status;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
	toggleHideLostBets(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.hideLostBets = !settings.hideLostBets;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
	changeTheme(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.themeV2.dark = !settings.themeV2.dark;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
		if (settings.themeV2.dark)
			document.querySelector("html").classList.remove("dark");
		if (!settings.themeV2.dark)
			document.querySelector("html").classList.add("dark");
	},
	activateCard(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.seeRecommendations = !settings.seeRecommendations;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
